import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import { Button, Heading, Stack, Text } from '@eluve/components';
import { SwapAppointmentPatientsDialog } from '@eluve/smart-blocks';

export const SwapAppointmentsPage: React.FC = () => {
  const { tenantId } = useParams() as { tenantId: string };
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <Stack gap={8} align="center" className="mx-auto max-w-2xl p-6">
      <Heading size="xl" level={1}>
        Swap Appointments
      </Heading>
      <Stack gap={4}>
        <Text color="tertiary" className="text-center text-balance">
          For when a provider recorded two sessions against each other's
          patients. Given two appointment IDs, this tool exchanges their
          patients, names, and start/end times, and re-points their external EHR
          appointment links if any. Each appointment keeps its own transcript
          and notes, so after the swap both show the correct content.
        </Text>
        <Text color="tertiary" className="text-center text-balance">
          Both appointments must belong to this organization and the same owner,
          be completed, and have different patients. The swap is refused if a
          note was already synced to the EHR for either appointment (that must
          be corrected in the EHR manually). Appointments with signed notes are
          allowed and flagged in the preview.
        </Text>
        <Text color="tertiary" className="text-center text-balance">
          Both appointments are tagged with{' '}
          <span className="font-mono">RECORDED_AGAINST_WRONG_PATIENT</span> and{' '}
          <span className="font-mono">ON_CALL_INTERVENTION</span> for
          auditability. Known limitation for Boulevard: the Eluve deep link
          inside the Boulevard booking notes is not rewritten.
        </Text>
      </Stack>
      <Button onClick={() => setIsDialogOpen(true)}>Start</Button>
      <SwapAppointmentPatientsDialog
        tenantId={tenantId}
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
      />
    </Stack>
  );
};
